import {useCallback} from "react";

import {useMutation} from "@khan/data-gql";
import {Errors, KAError} from "@khan/logging";

import type {khanmigoToolsUpdateBlooketV2Variables} from "../graphql/__graphql-types__/khanmigoToolsUpdateBlooketV2.ts";
import {UPDATE_BLOOKET_MUTATION_V2} from "../graphql/update-blooket-mutation-v2.ts";

export const useUpdateBlooketMutation = (): ((
    variables: khanmigoToolsUpdateBlooketV2Variables,
) => Promise<void>) => {
    const [mutate] = useMutation(UPDATE_BLOOKET_MUTATION_V2);

    return useCallback(
        (variables: khanmigoToolsUpdateBlooketV2Variables) => {
            return mutate(variables)
                .then((result) => {
                    // If we have an error status or we got a successful
                    // response but it has an error in it, then we throw an
                    // error.
                    const error =
                        result.status === "error"
                            ? result.error
                            : result.status === "success" &&
                                result.data.updateBlooketQuestionSetV2.error
                              ? result.data.updateBlooketQuestionSetV2.error
                                    .code
                              : null;

                    if (error) {
                        throw new KAError(
                            "Failed to update blooket",
                            Errors.Internal,
                            {
                                cause: error,
                            },
                        );
                    }
                })
                .catch((error) => {
                    if (error instanceof KAError) {
                        throw error;
                    }

                    throw new KAError(
                        "Failed to update blooket",
                        Errors.Internal,
                    );
                });
        },
        [mutate],
    );
};
